import { Row, Col } from "react-bootstrap";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import React from "react";
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";
import { useLocation } from "react-router-dom";

const StepForm3 = ({handleSubmit}) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const lastSegment = pathSegments[pathSegments.length - 1];


  const { sharedSafariDispatch } = useSharedSafariContext();
  const { mobileVerifyDispatch } = useMobileVerifyContext();

  const handleClose = () => {
    mobileVerifyDispatch({ type: "MOBILE_VERIFY_TOGGLE", payload: false });
  }

  const handleActions = () => {
    if (lastSegment === 'sharedsafari') {
      sharedSafariDispatch({ type: "ORGANIZE_SHARE_SAFARI_TOGGLE", payload: true });
    } else {
      mobileVerifyDispatch({ type: "MOBILE_VERIFY_TOGGLE", payload: false });
      handleSubmit();
    }

  }

  return (
    <Row className="pt-5 mt-5">
      <Col xs={12} className="mb-3 text-center">
        <p className="mobile-verify-heading m-0">You're verified!</p>
        <p className="font_colorfomr px-lg-5 mt-0 pt-0">
          {lastSegment === 'sharedsafari' ? "Create your Shared Safari and let others join your adventure"
            : ""
          }
        </p>
      </Col>

      <Col className="pb-5">
        <div className="d-flex justify-content-center position-relative ">
          <button className="btn_newsafari_w organizeBtn newbg d-block text-center " onClick={() => {
            handleActions()
          }}>
            {lastSegment === 'sharedsafari' ?  "Create Shared Safai" : "Submit Quote Request"}
            
            </button>
        </div>
      </Col>

      <Col lg={12} className="margin-remove pt-5">
        <div className="creat-safri d-flex justify-content-end">
          <button
            type="button"
            className="cancel_btn_safari"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </Col>
    </Row>
  );
};

export default StepForm3;
